
import { Component, Prop, Vue } from 'vue-property-decorator';
import { get, put } from '@/services/http';
import { StoreModel } from '@/models/store';
import CopyLinkButton from '@/components/CopyLinkButton.vue';

@Component({
  components: {
    CopyLinkButton,
  },
})
export default class LandedCostSettings extends Vue {
  @Prop({ type: Object, required: true }) store!: StoreModel;

  private loading = false;
  private saving = false;
  private hasChanges = false;
  private method = 'ratio';
  private showSuccess = false;
  private showError = false;
  private errorMessage = '';

  async mounted() {
    await this.fetchPreferences();
  }

  private async fetchPreferences() {
    this.loading = true;
    try {
      const response: any = await get('/purchase_orders/config/landed-cost');
      if (response.data?.method) {
        this.method = response.data.method;
      }
    } catch (error: any) {
      console.error('Failed to fetch landed cost preferences:', error);
    } finally {
      this.loading = false;
    }
  }

  private async save() {
    this.saving = true;
    try {
      await put('/purchase_orders/config/landed-cost', { method: this.method });
      this.hasChanges = false;
      this.showSuccess = true;
    } catch (error: any) {
      this.errorMessage = error?.response?.data?.message || 'Failed to save preferences';
      this.showError = true;
    } finally {
      this.saving = false;
    }
  }
}
